import script from "./legoValidator.vue?vue&type=script&lang=js"
export * from "./legoValidator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/lego-component/components/element/legoValidator/legoValidator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8637088"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8637088', __exports__)) {
    api.reload('a8637088', __exports__)
  }
  
}


export default __exports__